var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ion-app',[_c('ion-split-pane',[(_vm.isAuthenticated)?_c('Menu'):_vm._e(),_c('ion-vue-router',{attrs:{"main":"","animated":false,"id":"menu-content"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }